import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Badge,
  Table
} from "reactstrap";
import { getAdminNotifications, markAsRead, IAdminNotification } from "./_requests";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import moment from "moment";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";

const Notifications = () => {
    const [notifications, setNotifications] = useState<IAdminNotification[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchNotifications = async () => {
        setLoading(true);
        try {
            const response = await getAdminNotifications();
            if (response.status) {
                setNotifications(response.data);
            }
        } catch (error) {
            console.error("Error fetching notifications", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, []);

    const handleMarkAsRead = async (id: number) => {
        try {
            await markAsRead(id);
            fetchNotifications();
        } catch (error) {
            console.error("Error marking as read", error);
        }
    };

    const handleNotificationClick = (notif: any) => {
        if (!notif.is_read) {
            handleMarkAsRead(notif.id);
        }
        
        if (notif.category === "ORDER") {
            navigate("/orders");
        } else if (notif.category === "SUBSCRIPTION") {
            navigate("/user-subscription");
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Notifications" pageTitle="Dashboard" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">All Notifications</h5>
                                    <div className="flex-shrink-0">
                                        <Button color="primary" size="sm" onClick={fetchNotifications}>
                                            <i className="ri-refresh-line align-bottom me-1"></i> Refresh
                                        </Button>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="align-middle table-nowrap mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Title</th>
                                                    <th scope="col">Description</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Category</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {notifications.length > 0 ? (
                                                    notifications.map((notif, index) => (
                                                        <tr key={index} className={classnames({ "table-info": !notif.is_read })}>
                                                            <td>
                                                                {!notif.is_read ? (
                                                                    <Badge color="danger">Unread</Badge>
                                                                ) : (
                                                                    <Badge color="light" className="text-body">Read</Badge>
                                                                )}
                                                            </td>
                                                            <td className="fw-medium">{notif.title}</td>
                                                            <td style={{ whiteSpace: 'normal', minWidth: '300px' }}>{notif.description}</td>
                                                            <td>{moment(notif.created_at).format("DD MMM, YYYY hh:mm A")}</td>
                                                            <td>
                                                                <Badge 
                                                                    color={notif.category === 'ORDER' ? "info" : "success"}
                                                                    className="text-uppercase"
                                                                >
                                                                    {notif.category}
                                                                </Badge>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex gap-2">
                                                                    <Button 
                                                                        color="light" 
                                                                        size="sm"
                                                                        onClick={() => handleNotificationClick(notif)}
                                                                    >
                                                                        View Details
                                                                    </Button>
                                                                    {!notif.is_read && (
                                                                        <Button 
                                                                            color="soft-primary" 
                                                                            size="sm"
                                                                            onClick={() => handleMarkAsRead(notif.id)}
                                                                        >
                                                                            Mark as Read
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6} className="text-center">
                                                            {loading ? "Loading..." : "No notifications found"}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Notifications;
